export type LandingCard = {
  title: string;
  summary?: string;
  icon: string; // path to an image under /assets/images
  link: string;
  linkText?: string;
  target?: string;
  managerOnly?: boolean;
};

export const landingCards: LandingCard[] = [
  {
    title: "Submit a new Citizenship Fee Assistance application",
    icon: "/assets/images/Thumbnail.svg",
    link: "/citizenship/apply",
    linkText: "Start a new application",
  },
  {
    title: "Check your application status and upload supporting documents",
    icon: "/assets/images/heart-illustrative.svg",
    link: "/citizenship/upload-document",
    linkText: "View my status and upload documents",
  },
  {
    title: "Manager portal",
    icon: "/assets/images/Manager-Thumbnail.svg",
    link: "/citizenship/manager-portal",
    linkText: "Review application and paid day off",
    managerOnly: true,
  },

  {
    title: "View helpful information, FAQs, and guidance documents",
    icon: "/assets/images/resources-illustrative.svg",
    link: "https://www.kpcareerplanning.org/prd/citizenship_reimbursement.php",
    linkText: "Learn more about reimbursement",
    target: "_blank",
  },
];

export default landingCards;

export const adminLandingCards: LandingCard[] = [
  {
    title: "Tuition reimbursement",
    icon: "/assets/images/document-heart-illustrative.svg",
    link: "/admin/tuition",
    linkText: "Manage applications",
  },
  {
    title: "Citizenship reimbursement",
    icon: "/assets/images/Thumbnail.svg",
    link: "/admin/citizenship",
    linkText: "Manage applications",
  },
  {
    title: "Administer",
    icon: "/assets/images/Thumbnail.svg",
    link: "/admin/administer",
    linkText: "System admin functions",
  },
  {
    title: "Canned responses",
    icon: "/assets/images/resources-illustrative.svg",
    link: "/tuition/admin/canned-responses",
    linkText: "Manage canned responses",
    target: "_blank",
  },
];
